var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, Text } from 'wix-style-react';
import * as React from 'react';
export var BusinessInfoLine = function (_a) {
    var verticalLayout = _a.verticalLayout, _b = _a.textProps, textProps = _b === void 0 ? {} : _b, dataHook = _a.dataHook, value = _a.value;
    return (React.createElement(Box, { wordBreak: 'break-word', direction: "vertical", paddingTop: "4px" },
        React.createElement(Text, __assign({ size: "tiny", secondary: true, verticalLayout: verticalLayout, dataHook: dataHook }, textProps), value)));
};
//# sourceMappingURL=BusinessInfoLine.js.map